var exports = {
  "k": "x61f99309--eef979--container",
  "x": "x61f99309--eef979--button",
};

module.exports = exports;
